import { render } from "./ManagerAddStaff.vue?vue&type=template&id=74f7ab9e&scoped=true"
import script from "./ManagerAddStaff.vue?vue&type=script&lang=js"
export * from "./ManagerAddStaff.vue?vue&type=script&lang=js"

import "./ManagerAddStaff.vue?vue&type=style&index=0&id=74f7ab9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f7ab9e"]])

export default __exports__